import clsx from 'clsx';
import {CustomMenu} from '../../menus/custom-menu';
import {LocaleSwitcher} from '../../i18n/locale-switcher';
import {Button} from '../buttons/button';
import {DarkModeIcon} from '../../icons/material/DarkMode';
import {LightbulbIcon} from '../../icons/material/Lightbulb';
import {Trans} from '../../i18n/trans';
import {useThemeSelector} from '../themes/theme-selector-context';
import {useSettings} from '../../core/settings/use-settings';

interface Props {
  className?: string;
  padding?: string;
}

function handleClick() {
  console.log("Button clicked");
  location.href="/login";
}

export function Footer({className, padding}: Props) {
  const year = new Date().getFullYear();
  const {branding} = useSettings();
  return (
    <footer
      className={clsx(
        'text-sm',
        padding ? padding : 'pb-28 pt-54 md:pb-54',
        className,
      )}
    >
      <Menus />
      <div className="items-center justify-between gap-30 text-center text-muted md:flex md:text-left">
        <Trans
          message="Copyright © :year :name, All Rights Reserved"
          values={{year, name: branding.site_name}}
        />
        <div>
          {/* <ThemeSwitcher /> */}
          {/* <LocaleSwitcher /> */}
        </div>
      </div>

      <div id='footer_div_2'>
        <button id='footer_button' onClick={handleClick}>Ücretsiz link oluştur</button>
      </div>
     
      <div id='footer_div'>
         <svg xmlns="http://www.w3.org/2000/svg" width="142" height="25" viewBox="0 0 142 25" fill="none"> <path d="M0.5 11.847C0.5 5.8266 5.38053 0.946065 11.401 0.946065H18.9094C24.9298 0.946065 29.8104 5.8266 29.8104 11.847C29.8104 13.131 28.7695 14.1719 27.4855 14.1719C26.2015 14.1719 25.1607 13.131 25.1607 11.847C25.1607 8.39456 22.3619 5.59577 18.9094 5.59577H11.401C7.9485 5.59577 5.14971 8.39456 5.14971 11.847C5.14971 15.2995 7.9485 18.0983 11.401 18.0983H13.898C15.182 18.0983 16.2229 19.1392 16.2229 20.4232C16.2229 21.7072 15.182 22.748 13.898 22.748H11.401C10.2071 22.748 9.05805 22.5561 7.983 22.2014L3.45888 24.148C2.33333 24.5969 1.43659 24.5086 1.81696 23.0622L2.78945 18.5317C1.3545 16.6857 0.5 14.3662 0.5 11.847Z" fill="#9E9E9E"></path>  <path d="M37.0156 22.2019C35.941 22.5563 34.7924 22.748 33.599 22.748H26.0906C20.0702 22.748 15.1896 17.8675 15.1896 11.8471C15.1896 10.5631 16.2305 9.52221 17.5145 9.52221C18.7985 9.52221 19.8393 10.5631 19.8393 11.8471C19.8393 15.2995 22.6381 18.0983 26.0906 18.0983H33.599C37.0515 18.0983 39.8503 15.2995 39.8503 11.8471C39.8503 8.39458 37.0515 5.59579 33.599 5.59579H31.2853C30.0013 5.59579 28.9605 4.55492 28.9605 3.27094C28.9605 1.98696 30.0013 0.946085 31.2853 0.946085H33.599C39.6195 0.946085 44.5 5.82662 44.5 11.8471C44.5 14.3673 43.6447 16.6878 42.2086 18.5341C40.5512 20.7229 39.3689 21.4594 37.0156 22.2019Z" fill="#9E9E9E"></path>  <path d="M48.6343 0.946065H52.7299V19.4071H64.4743V22.9978H48.6343V0.946065Z" fill="#9E9E9E"></path>  <path d="M75.8158 8.12107C74.8788 8.34916 73.8936 8.74621 72.8602 9.31222V12.9237C73.1842 12.628 73.5433 12.3661 73.9374 12.138C74.3314 11.9015 74.7386 11.7072 75.159 11.5551C75.5881 11.3946 76.0216 11.2721 76.4594 11.1876C76.906 11.1032 77.3395 11.0609 77.7599 11.0609C78.5568 11.0609 79.2749 11.1792 79.9141 11.4157C80.5622 11.6438 81.1095 11.9817 81.5561 12.4295C82.0115 12.8688 82.3574 13.4137 82.5938 14.0641C82.839 14.7062 82.9616 15.4369 82.9616 16.2564V22.9978H86.8367V15.6481C86.8367 14.3556 86.6265 13.2194 86.2062 12.2394C85.7946 11.251 85.221 10.4273 84.4854 9.7684C83.7498 9.10947 82.8784 8.61527 81.8714 8.2858C80.8643 7.94789 79.7696 7.77893 78.5874 7.77893C77.6854 7.77893 76.7616 7.89297 75.8158 8.12107Z" fill="#9E9E9E"></path>  <path d="M88.7002 0.946045H92.4736V14.1245L99.756 7.57736H105.285L97.4198 14.791L105.783 22.9978H100.122L94.526 17.4438L92.4736 19.3257V22.9978H88.7002V0.946045Z" fill="#9E9E9E"></path>  <path d="M109.725 4.8284H99.8814L99.8815 0.946045H120.38L120.38 4.8284H114.137L114.137 22.9978H109.725L109.725 4.8284Z" fill="#9E9E9E"></path>  <path d="M68.5047 5.6332C68.0788 5.6332 67.6915 5.5814 67.343 5.47781C67.0042 5.36559 66.7138 5.21883 66.4718 5.03755C66.2297 4.84763 66.041 4.63181 65.9054 4.3901C65.7796 4.13975 65.7167 3.87645 65.7167 3.60021C65.7167 3.31533 65.7796 3.05203 65.9054 2.81032C66.041 2.55997 66.2297 2.34416 66.4718 2.16287C66.7138 1.98158 67.0042 1.83915 67.343 1.73555C67.6915 1.62333 68.0788 1.56722 68.5047 1.56722C68.9403 1.56722 69.3276 1.62333 69.6664 1.73555C70.0149 1.83915 70.3101 1.98158 70.5522 2.16287C70.7942 2.34416 70.9781 2.55997 71.104 2.81032C71.2395 3.05203 71.3073 3.31533 71.3073 3.60021C71.3073 3.87645 71.2395 4.13975 71.104 4.3901C70.9781 4.63181 70.7942 4.84763 70.5522 5.03755C70.3101 5.21883 70.0149 5.36559 69.6664 5.47781C69.3276 5.5814 68.9403 5.6332 68.5047 5.6332ZM66.3556 7.71799H70.6538V22.9978H66.3556V7.71799Z" fill="#9E9E9E"></path>  <path d="M124.85 4.8284V0.946045H131.589C133.281 0.946045 134.747 1.12475 135.988 1.48217C137.228 1.83018 138.258 2.33809 139.075 3.0059C139.893 3.67371 140.499 4.48731 140.894 5.44669C141.298 6.40608 141.5 7.49244 141.5 8.70578C141.5 9.52408 141.402 10.3048 141.204 11.0478C141.007 11.7815 140.701 12.4587 140.288 13.0795C139.884 13.7002 139.371 14.2552 138.751 14.7443C138.131 15.224 137.402 15.6237 136.566 15.9435L141.359 22.9978H135.889L131.744 16.7336H131.617L124.85 16.7195V22.9978H120.38V4.8284H124.85ZM131.702 12.8537C132.548 12.8537 133.285 12.755 133.915 12.5574C134.554 12.3599 135.085 12.0824 135.508 11.725C135.941 11.3676 136.26 10.9349 136.467 10.427C136.683 9.90972 136.791 9.33597 136.791 8.70578C136.791 7.47363 136.368 6.52365 135.522 5.85584C134.676 5.17863 133.403 4.8284 131.702 4.8284H124.85V12.8537H131.702Z" fill="#9E9E9E"></path></svg>
      </div>

      
      
    </footer>
  );
}

function Menus() {
  const settings = useSettings();
  const primaryMenu = settings.menus.find(m => m.positions?.includes('footer'));
  const secondaryMenu = settings.menus.find(
    m => m.positions?.includes('footer-secondary'),
  );

  if (!primaryMenu && !secondaryMenu) return null;

  return (
    <div className="mb-14 items-center justify-between gap-30 overflow-x-auto border-b pb-14 md:flex">
      {primaryMenu && (
        <CustomMenu menu={primaryMenu} className="text-primary" />
      )}
      {secondaryMenu && (
        <CustomMenu menu={secondaryMenu} className="mb:mt-0 mt-14 text-muted" />
      )}
    </div>
  );
}

function ThemeSwitcher() {
  const {themes} = useSettings();
  const {selectedTheme, selectTheme} = useThemeSelector();
  if (!selectedTheme || !themes?.user_change) return null;

  return (
    <Button
      variant="text"
      startIcon={selectedTheme.is_dark ? <DarkModeIcon /> : <LightbulbIcon />}
      onClick={() => {
        if (selectedTheme.is_dark) {
          selectTheme('light');
        } else {
          selectTheme('dark');
        }
      }}
    >
      {selectedTheme.is_dark ? (
        <Trans message="Light mode" />
      ) : (
        <Trans message="Dark mode" />
      )}
    </Button>
  );
}
